import {
  BaseApiService,
} from '@/services/base-api-service';
import {
  Profile,
} from '@/services/types/profile-api-service';

class ProfileApiService extends BaseApiService {
  constructor() {
    super(`${__config.url.api}/auth`, true);
  }

  public get(): Promise<Profile> {
    return this.http.get('/me');
  }
}

export const profileApiService = new ProfileApiService();
